//  const API_URL = "http://localhost:3001";
const API_URL = 'https://apiserver.wishours.com'
// const API_URL = "https://apitriplast.articloo.com";


const Apis = {
  UserLogin: `${API_URL}/api/auth/sign-in`,
  GetUserProfile: `${API_URL}/api/admin/profile`,
  UpdateUserProfile: `${API_URL}/api/admin/profile/update`,
  CheckUserCurrentPassword: `${API_URL}/api/admin/check/password`,
  UpdateUserPassword: `${API_URL}/api/admin/update/password`,
  GetAllUsers: `${API_URL}/api/user/all`,
  GetSinleUser: `${API_URL}/api/user/`,
  UpdateCustomer:`${API_URL}/api/customer/update`, 
  SearchUserByEmail: `${API_URL}/api/user/email/search`, 
  GetAllCategories: `${API_URL}/api/categories`,
  CreateCategory: `${API_URL}/api/category/create`,
  DeleteCategory: `${API_URL}/api/category/`,
  SingleCategory: `${API_URL}/api/category/`,
  UpdateCategory: `${API_URL}/api/category/`,
  GetCategoryFaqs: `${API_URL}/api/category/faq/`,
  CreateCategoryFaq: `${API_URL}/api/category/faq/create/`,
  DeleteCategoryFaq: `${API_URL}/api/category/faq/`,
  UpdateCategoryFaq: `${API_URL}/api/category/faq/update/`,
  CreateProduct: `${API_URL}/api/product/create`,
  UpdateProduct: `${API_URL}/api/product/edit/`,
  GetAllProducts: `${API_URL}/api/products`,
  GetSingleProduct: `${API_URL}/api/products/`,
  CreateProductGallery: `${API_URL}/api/product/gallery/`,
  GetProductGallery: `${API_URL}/api/product/gallery/`,
  ProductGalleryDelete: `${API_URL}/api/product/gallery/`,
  CreateProductCategoryVariation: `${API_URL}/api/category/variation/create`,
  UpdateProductVariation: `${API_URL}/api/product/variations/update/`,
  CreateVariation: `${API_URL}/api/variation/create`,
  UpdateVariationData: `${API_URL}/api/variation/update/`,
  GetVariations: `${API_URL}/api/variation/all`,
  CreateProductVariations: `${API_URL}/api/product/variations/create`,
  GetCategoryVariations: `${API_URL}/api/category/variation/all`,
  GetSingleVariation: `${API_URL}/api/category/variation/`,
  DeleteVariation: `${API_URL}/api/variation/`,
  DeleteCategoryVariation: `${API_URL}/api/category/variation/`,
  UpdateVariation: `${API_URL}/api/category/variation/`,
  CreateVariationOption: `${API_URL}/api/category/variation/option/create`,
  EditVariationOption: `${API_URL}/api/category/variation/option/`,
  DeleteVariationOption: `${API_URL}/api/variation/option/`,
  GetAllVariationOptions: `${API_URL}/api/category/variation/option/all`,
  GetProductVariations: `${API_URL}/api/product/category/variations/`,
  GetCategoryWiseVariations: `${API_URL}/api/category/variations/`,
  GetProductVariation: `${API_URL}/api/product/variation/`,
  DeleteProductVariation: `${API_URL}/api/product/variation/delete/`,
  SearchProducts: `${API_URL}/api/search/products`,
  GetProductById:`${API_URL}/api/getOroductsById/`,
  GetSpecifications: `${API_URL}/api/specifications`,
  CreateSpecification: `${API_URL}/api/specification/create`,
  EditSpecification: `${API_URL}/api/specification/edit/`,
  DeleteSpecification: `${API_URL}/api/specification/delete/`,
  CreateProductSpecific: `${API_URL}/api/product/specification/create`,
  GetProductSpecification: `${API_URL}/api/product/specifications/`,
  DeleteProductSpecification: `${API_URL}/api/product/specification/delete/`,
  UpdateProductSpecification: `${API_URL}/api/product/specification/update/`,

  //Orders
  GetAllOrders: `${API_URL}/api/orders/all`,
  GetSingleOrderPayments: `${API_URL}/api/orders/payments/`,
  GetSingleOrders: `${API_URL}/api/orders/`,
  GenerateOrderInvoice: `${API_URL}/api/orders/invoice/`,
  GenerateOrdersInvoice: `${API_URL}/api/orders/invoices`,
  UpdateOrderStatus: `${API_URL}/api/orders/status/`,
  UpdatePaymentStatus: `${API_URL}/api/orders/payment/status/`,
  RecentOrders: `${API_URL}/api/orders/recent`,
  UpdateOrderNote: `${API_URL}/api/order/order-note/udpate/`,
  CreateCheckoutSession: `${API_URL}/api/order/createCheckoutSession`, 
  ResendCheckoutSession: `${API_URL}/api/order/resendCheckoutSession`,   
  CreateAdminOrder: `${API_URL}/api/order/admin/create`, 
  ExportOrders: `${API_URL}/api/order/export`,
  ProcessOrder:`${API_URL}/api/order/process/`,
  CancelOrder:`${API_URL}/api/order/cancel/`, 
  CancelOrderApproval:`${API_URL}/api/order/cancel/approval/`,    
  //OrderNote
  AddOrderNote: `${API_URL}/api/order/note/create`,
  UpdateOrderNote2: `${API_URL}/api/order/note/update/`,
  DeleteOrderNote: `${API_URL}/api/order/note/delete`,

  //Refund
  CreateOrderRefund: `${API_URL}/api/order/create/refund`,


  //Cart
  GetAllCartItems:`${API_URL}/api/get/carts`,
  SendAbandonmentEmail:`${API_URL}/api/send-abandonment-emails`, 

  //Inventory
  GetInventoryProducts: `${API_URL}/api/inventory/all`,
  UpdateInventory: `${API_URL}/api/inventory/update/`,

  //Product Faqs
  CreateProductFaq: `${API_URL}/api/product/faq/create`,
  GetProductFaqs: `${API_URL}/api/product/faq/all/`,
  GetSingleProductFaq: `${API_URL}/api/product/faq/`,
  DeleteProductFaq: `${API_URL}/api/product/faq/delete/`,
  UpdateProductFaq: `${API_URL}/api/product/faq/update/`,




  CreateProductVariationGallery: `${API_URL}/api/product/variation/gallery/create`,
  DeleteProductVariationGallery: `${API_URL}/api/product/variation/gallery/delete/`,
  CreateProductVariationContent: `${API_URL}/api/product/variation/content/create`,
  UpdateProductVariationContent: `${API_URL}/api/product/variation/content/update/`,
  UpdateVariationGalleryPosition: `${API_URL}/api/product/variation/gallery/order`,
  UpdateGalleryPosition: `${API_URL}/api/product/gallery/order/update`,
  DeleteProduct: `${API_URL}/api/product/delete/`,
  //Media Routes
  CreateMedia: `${API_URL}/api/media/create`,
  CreateVideoMedia: `${API_URL}/api/media/video/create`,

  UpdateMedia: `${API_URL}/api/media/update/`,

  GetAllMedia: `${API_URL}/api/media/all`,
  GetAllMediaShow: `${API_URL}/api/media/all/export`,

  DeleteMultipleMedia: `${API_URL}/api/media/delete`,
  DeleteMedia: `${API_URL}/api/media/`,



  //Post Categories
  GetAllPostCategories: `${API_URL}/api/post/categories`,
  CreatePostCategory: `${API_URL}/api/post/category/create`,
  DeletePostCategory: `${API_URL}/api/post/category/`,
  SinglePostCategory: `${API_URL}/api/post/category/`,
  UpdatePostCategory: `${API_URL}/api/post/category/`,
  CreatePost: `${API_URL}/api/post/create`,
  GetAllPost: `${API_URL}/api/posts`,
  GetSinglePost: `${API_URL}/api/post/`,
  DeletePost: `${API_URL}/api/post/`,
  UpdatePost: `${API_URL}/api/post/`,
  UploadCkeditor: `${API_URL}/api/ckeditor/upload`,

  //Settings
  GetCurrencies: `${API_URL}/api/currencies`,
  GetSettings: `${API_URL}/api/settings`,
  UpdateVatSettings: `${API_URL}/api/settings/update/vat`,
  GetSeoDetails: `${API_URL}/api/settings/seo/`,
  UpdateSeoDetails: `${API_URL}/api/settings/seo/update/`,
  GetSeoPages: `${API_URL}/api/settings/seo/pages`,

  //Reviews
  GetReviews: `${API_URL}/api/reviews`,
  UpdateReviews: `${API_URL}/api/reviews/status/`,
  DeleteReviews: `${API_URL}/api/reviews/delete/`,

  //Product Import
  ImportSimpleProduct: `${API_URL}/api/product/upload/csv`,
  ImportVariationProduct: `${API_URL}/api/variation/product/upload/csv`,
  ProductExportProcess:`${API_URL}/api/product/export-products`,
  DownloadExportedProduct:`${API_URL}/api/product/export-products/download`,


  //Coupons
  CreateCoupons: `${API_URL}/api/coupons/create`,
  GetCoupons: `${API_URL}/api/coupons`,
  GetSingleCoupon: `${API_URL}/api/coupons/`,
  UpdateCoupon: `${API_URL}/api/coupons/update/`,
  DeleteCoupon: `${API_URL}/api/coupons/delete/`,


  //Update 
  UpdateProductVariations: `${API_URL}/api/product/variation/update`,
  UpdateUserAddress: `${API_URL}/api/address/update/`,
  AddShippingAddress: `${API_URL}/api/order/shipping/address/addNew/`,
  AddBillingAddress: `${API_URL}/api/order/billing/address/addNew/`,
  MakeSameBillingShippingAddress: `${API_URL}/api/order/shipping-billing/address/same/`,
  AddNewUser:`${API_URL}/api/customer/add/new`, 
  VerifyNewUser:`${API_URL}/api/verify/user`, 
  ResendOtp:`${API_URL}/api/customer/resentOtp`, 
  ExportUsers:`${API_URL}/api/export/users`,    
  ImportUsers:`${API_URL}/api/import/user/csv`,  
  AddNewAddress:`${API_URL}/api/address/new/`,  
  GetDashboard:`${API_URL}/api/get-dashboard`,  


  //Shipping Zone Country
  CreateShippingZoneCountry:`${API_URL}/api/shipping-countries/create`,  
  UpdateShippingZoneCountry:`${API_URL}/api/shipping-countries/update/`,  
  DeleteShippingZoneCountry:`${API_URL}/api/shipping-countries/delete/`,  
  GetShippingZoneCountry:`${API_URL}/api/get-shipping-countries`,  

  //Shipping Rate Labels
  CreateShippingRateLabel:`${API_URL}/api/shipping-rate-labels/create`,  
  UpdateShippingRateLabel:`${API_URL}/api/shipping-rate-labels/update/`,  
  DeleteShippingRateLabel:`${API_URL}/api/shipping-rate-labels/delete/`,  
  GetShippingRateLabel:`${API_URL}/api/get-shipping-rate-labels`,  

  //Shipping Zone
   GetShippingZones:`${API_URL}/api/shipping-zones`,  
   CreateShippingZone:`${API_URL}/api/shipping-zone/create`,  
   UpdateShippingZone:`${API_URL}/api/shipping-zone/update/`,   
   DeleteShippingZone:`${API_URL}/api/shipping-zone/delete/`, 
   GetShippingMethods:`${API_URL}/api/get-shipping-zones`,    

   //Shipping Zone Rates
   CreateShippingZoneRate:`${API_URL}/api/shipping-zone/rate/create`,   
   GetAllShippingZoneRates:`${API_URL}/api/shipping-zone/rates`,
   AssociateShippingZoneRates:`${API_URL}/api/shipping-zone/rate/associate`,
   UpdateShippingZoneRate:`${API_URL}/api/shipping-zone/rates/update/`,  
   DeleteShippingZoneRates:`${API_URL}/api/shipping-zone/rates/delete/`,
   DeleteShippingZoneRate:`${API_URL}/api/shipping-zone-rate/delete/`,

   //Email
   CreateEmailTemplate:`${API_URL}/api/email-template/create`,   
   UpdateEmailTemplate:`${API_URL}/api/email-template/update/`,
   DeleteEmailTemplate:`${API_URL}/api/email-template/delete/`,
   GetAllEmailTemplate:`${API_URL}/api/get-email-templates`,  
   GetSingleEmailTemplate:`${API_URL}/api/get-single-template/`,  
  

  //Linnworks
  UpdateShippingAddress: `${API_URL}/api/order/shipping-address/udpate/`,
  UpdateBillingAddress: `${API_URL}/api/order/billing-address/udpate/`,

};
export { API_URL, Apis };